import { useEffect } from "react";
import { useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import switchTab from "@fas/cpa-state-manager/redux/actions/tabs";

export type UseParamTabsArgs<T extends Record<string, string>> = {
  pageKey: string;
  paramKey: string;
  paramsToTabs: T;
};

export type UseParamTabsHook<T extends Record<string, string>> = {
  param: keyof T;
};

export const useParamTabs = <T extends Record<string, string>>({
  pageKey,
  paramKey,
  paramsToTabs,
}: UseParamTabsArgs<T>): UseParamTabsHook<T> => {
  const dispatch = useDispatch();
  const params = useParams();
  const value = params[paramKey];
  const keys = Object.keys(paramsToTabs) as (keyof T)[];
  const param = (value && keys.includes(value) ? value : "default") as keyof T;
  useEffect(() => {
    if (keys.includes(param)) {
      dispatch(switchTab(pageKey, paramsToTabs[param] as string));
    }
  }, [dispatch, pageKey, param, paramsToTabs]);
  return {
    param,
  };
};
